import { NoServiceItem } from './ServicesController.types';

export const NO_SERVICE_ITEM: NoServiceItem = 'NO_SERVICE';
